<h1 mat-dialog-title [ngSwitch]="data.type">
    <i *ngSwitchCase="'error'" class="header-icon material-icons">error</i>
    <i *ngSwitchCase="'warn'" class="header-icon material-icons">warning</i>
    <i *ngSwitchCase="'accent'" class="header-icon material-icons">check_circle</i>
    <i *ngSwitchDefault class="header-icon material-icons">info</i>
    {{((data.title || '') | mxTranslate)()}}
</h1>
<div mat-dialog-content style="height: 85%;" [ngSwitch]="data.contentType">
    <p *ngSwitchCase="'json'">{{(data.message.toString() | mxTranslate)()}}</p>
    <iframe *ngSwitchCase="'iframe'" [srcdoc]="data.message" width="100%" height="90%" frameborder="0"></iframe>
    <p *ngSwitchDefault [innerHTML]="((data.message || '?') | mxTranslate)()"></p>
</div>
<div mat-dialog-actions>
    <ng-container *ngFor="let button of actionButtons.getArray()">
        <mx-button [buttonModel]="button"></mx-button>
    </ng-container>

    <mx-button [buttonModel]="closeButton"></mx-button>
    <mx-button [buttonModel]="okButton"></mx-button>
</div>
